import { render, staticRenderFns } from "./azure-disk.vue?vue&type=template&id=570a6d29&scoped=true&"
import script from "./azure-disk.vue?vue&type=script&lang=js&"
export * from "./azure-disk.vue?vue&type=script&lang=js&"
import style0 from "./azure-disk.vue?vue&type=style&index=0&id=570a6d29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a6d29",
  null
  
)

export default component.exports